import script from "./DeckListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DeckListItem.vue?vue&type=script&setup=true&lang=js"

import "./DeckListItem.vue?vue&type=style&index=0&id=503ec9c0&lang=css"

const __exports__ = script;

export default __exports__